export const MAX_STATUS_POINTS = 3
